import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import classNames from 'classnames';
import { FormInputButton } from 'components/FormInputButton.tsx/FormInputButton';
import type { FC, ReactNode, SyntheticEvent } from 'react';
import { getSizeCssClass } from 'utils/form/getSizeCssClass';
import './Tag.css';

export interface TagProps {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  hasError?: boolean;
  onRemove?: () => void;
  onClick?: () => void;
  size?: 'normal' | 'small' | 'tiny';
}

export const Tag: FC<TagProps> = (props) => {
  const handleRemoveClick = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();

    props.onRemove?.();
  };

  return (
    <div
      className={classNames(
        'tag',
        props.disabled && 'tag--disabled',
        props.hasError && 'tag--error',
        props.className,
        props.onClick && 'tag--clickable',
        getSizeCssClass(props.size, 'tag'),
      )}
    >
      <div className='tag__content'>{props.children}</div>
      {props.onRemove && (
        <FormInputButton
          className='ml-2'
          accent='negative'
          disabled={props.disabled}
          onClick={handleRemoveClick}
        >
          <Icon glyph='fa-xmark' size='xs' />
        </FormInputButton>
      )}
    </div>
  );
};
